module.exports = __webpack_public_path__ + "img/story-part-divider.870a2242.svg";